import { createContext } from 'react';

import type { WorkspaceContextValue } from './workspaceContextTypes';

export const WorkspaceContext = createContext<WorkspaceContextValue | null>(
  null
);
